<template>
    <section>
        <div class="header-line grid-container">
            <div class="profile-label grid-item" data-qa="recurringcharges-heading">
                Recurring charges
            </div>
        </div>
        <template lang="html">
            <div class="table-scroller">
                <ds-table-grid
                    :data="recurringCharges"
                    align="center"
                    :sort-field="sortField"
                    :sort-ascending="sortAscending"
                    @sort="sortTable"
                >
                    <ds-table-grid-column
                        label="Order"
                        width="130"
                    >
                        <template slot-scope="recurringCharge">
                            <span :title="recurringCharge.productName">
                                {{ modifyValidationMessage(recurringCharge.productName) }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Date"
                        width="80"
                        sortable
                    >
                        <template slot-scope="recurringCharge">
                            <span>
                                {{ dateFormatDate(recurringCharge.dateCreated, 'MMM D, YYYY') }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Payment plan"
                        width="140"
                    >
                        <template slot-scope="recurringCharge">
                            <span :title="recurringCharge.payPlanStatus">
                                {{ modifyValidationMessage(recurringCharge.payPlanStatus) }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Status"
                        width="130"
                    >
                        <template slot-scope="recurringCharge">
                            <span :title="recurringCharge.refundStatus">
                                {{ modifyValidationMessage(recurringCharge.refundStatus) }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Invoice total"
                        width="70"
                    >
                        <template slot-scope="recurringCharge">
                            <span>
                                {{ recurringCharge.invoiceTotalFormatted }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Amt paid"
                        prop="amtPaid"
                        width="50"
                    >
                        <template slot-scope="recurringCharge">
                            <span>
                                {{ recurringCharge.totalPaidFormatted }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Current bal."
                        width="60"
                    >
                        <template slot-scope="recurringCharge">
                            <span :class="checkValidMessage(recurringCharge.currentBalancePositive,recurringCharge.currentBalanceNegative)">
                                {{ recurringCharge.currentBalance }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Remaining bal."
                        prop="remainingBal"
                    >
                        <template slot-scope="recurringCharge">
                            <span>
                                {{ recurringCharge.remainingBalance }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>
        </template>
    </section>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        recurringCharges: Array,
    },

    data() {
        return {
            sortAscending: false,
            sortField: 'lastUpdated',
        };
    },

    methods: {
        dateFormatDate(date, format = 'll') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },

        checkValidMessage(positive, negetive) {
            if (positive) {
                return 'recurring-charge-positive';
            }

            if (negetive) {
                return 'recurring-charge-negative';
            }

            return null;
        },

        modifyValidationMessage(message) {
            if (message && message.length > 20) {
                return `${message.slice(0, 20)}...`;
            }

            return message;
        },

        sortTable({ ascending }) {
            const factor = ascending === true ? -1 : 1;

            this.sortAscending = ascending;
            this.recurringCharges = this.recurringCharges.sort((prev, next) => {
                if (prev.dateCreated > next.dateCreated) return -1 * factor;
                if (prev.dateCreated < next.dateCreated) return 1 * factor;

                return 0;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.header-line {
    display: flex;
}

.grid-container {
    display: flex;
    margin: $spacing-250 0;
}

.grid-item {
    margin: auto;
}

.profile-label {
    margin-left: 0;
    font-size: 1.75rem;
    color: $color-text;
}

.table-scroller {
    white-space: nowrap;
}

.recurring-charge-positive {
    color:$color-red;
}

.recurring-charge-negative {
    color:$color-blue;
}

@media only screen and ($medium) {
    .grid-container {
        margin-top: 1.875rem;
        display: block;
    }
}
</style>
